(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('rcopia-allergy-group', {
                parent: 'entity',
                url: '/rcopia-allergy-group',
                data: {
                    authorities: ['ROLE_SYSTEM_ADMIN'],
                    pageTitle: 'RcopiaAllergyGroups'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/rcopia-allergy-group/list/rcopia-allergy-groups.html',
                        controller: 'RcopiaAllergyGroupController',
                        controllerAs: 'vm'
                    }
                },
            });
    }

})();
